/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import Env from '@/env';
const apiVersion = 'api';
import AuthApis from '@/controllers/AuthApis';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /**
   * Fetch all locations
   */
  fetchWebsiteSetting(header:any = null) {
    const url = `${Env.loginUrl}/${apiVersion}/business-website-settings/show`;
    return AuthApis.getApi(url, header)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * Create  location
   */
  updateWebsiteSetting(data) {
    const url = `${Env.loginUrl}/${apiVersion}/business-website-settings/upsert`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

}